export interface OptimizeJobRequest {
    JobIds: string[],
    ConnectionId: string,
    Strategy?: number;
  }